/**
 * RadioGroup — basé sur `@radix-ui/react-radio-group`.
 */

import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import { cn } from '@/lib/utils/cn';

export type RadioGroupProps = ComponentPropsWithoutRef<typeof RadixRadioGroup.Root>;
export type RadioItemProps = ComponentPropsWithoutRef<typeof RadixRadioGroup.Item>;

export const RadioGroup = forwardRef<HTMLDivElement, RadioGroupProps>(function RadioGroup(
  { className, ...rest },
  ref,
) {
  return <RadixRadioGroup.Root ref={ref} className={cn('grid gap-2', className)} {...rest} />;
});

export const RadioItem = forwardRef<HTMLButtonElement, RadioItemProps>(function RadioItem(
  { className, children, ...rest },
  ref,
) {
  return (
    <RadixRadioGroup.Item
      ref={ref}
      className={cn(
        'border-border-strong bg-surface inline-flex size-4 shrink-0 items-center justify-center rounded-full border transition-colors',
        'data-[state=checked]:border-primary-500',
        'focus-visible:outline-primary-500 focus-visible:outline-2 focus-visible:outline-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...rest}
    >
      <RadixRadioGroup.Indicator className="bg-primary-500 block size-2 rounded-full" />
      {children}
    </RadixRadioGroup.Item>
  );
});
